import React, { Component, createRef } from "react";
import Row from "./Row.js";
import { VariableSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import AutoSizer from "react-virtualized-auto-sizer";

function defaultEasing(delta) {
  return delta;
}

class AnimatedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationInterrupted: false,
    };
    this.doneListScrollMax = { current: null };
    this.scrollOffset = { current: null };
  }

  static defaultProps = {
    duration: 1000,
    easing: defaultEasing,
    onAnimationComplete: () => {},
  };

  listRef = createRef();

  _scrollOffsetInitial = 0;
  _scrollOffsetFinal = 0;

  shouldComponentUpdate() {
    return true;
  }

  componentDidMount() {
    if (this.props.scrollOffset) {
      requestAnimationFrame(() => {
        this.listRef.current._listRef.scrollTo(this.props.scrollOffset);
      });
      this._scrollOffsetInitial = this.props.scrollOffset;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.scrollOffset !== prevProps.scrollOffset) {
      if (
        this.doneListScrollMax.current &&
        this.props.scrollOffset > this.doneListScrollMax.current
      ) {
        this.scrollOffset.current = this.doneListScrollMax.current;
      } else {
        this.scrollOffset.current = this.props.scrollOffset;
      }
      this._initAnimation();
    }
    if (this.props.scrollToLocation !== "unset") {
      this.props.setScrollToLocation("unset");
      if (this.props.scrollToLocation === "bottom") {
        this.listRef.current._listRef.scrollToItem(
          this.listRef.current._listRef.props.itemCount
        );
        this.props.setScrollToLocation("get_max_scroll");
      } else if (this.props.scrollToLocation === "top") {
        this.listRef.current._listRef.scrollToItem(0);
      }
    }
    if (this.props.itemData.months[0] !== prevProps.itemData.months[0]) {
      this.listRef.current._listRef.resetAfterIndex(0);
    }
  }

  render() {
    return (
      <AutoSizer>
        {({ height, width }) => (
          <InfiniteLoader {...this.props} ref={this.listRef}>
            {({ onItemsRendered, ref }) => (
              <List
                {...this.props}
                ref={ref}
                height={height}
                width={width}
                onItemsRendered={onItemsRendered}
                onScroll={this.onScroll}
              >
                {Row}
              </List>
            )}
          </InfiniteLoader>
        )}
      </AutoSizer>
    );
  }

  _animate() {
    requestAnimationFrame(() => {
      if (this.state.animationInterrupted) {
        this.setState({ animationInterrupted: false });
        return;
      }
      if (!this._animationStartTime) return;
      const { easing } = this.props;
      const now = performance.now();
      const ellapsed = now - this._animationStartTime;
      const scrollDelta = this._scrollOffsetFinal - this._scrollOffsetInitial;
      const easedTime = easing(Math.min(1, ellapsed / this._duration));
      const scrollOffset = this._scrollOffsetInitial + scrollDelta * easedTime;
      this.listRef.current &&
        this.listRef.current._listRef.scrollTo(scrollOffset);

      if (ellapsed < this._duration) {
        this._animate();
      } else {
        this._animationStartTime = undefined;
        this._scrollOffsetInitial = this._scrollOffsetFinal;
      }
    });
  }

  _initAnimation() {
    if (this._animationStartTime) {
      this.setState({ animationInterrupted: true });
    }
    const scrollOffset = this.scrollOffset.current;
    this._scrollOffsetFinal = scrollOffset;
    const distance = Math.abs(
      this._scrollOffsetFinal - this._scrollOffsetInitial
    );
    this._duration = 100 + 7 * distance;
    this._duration = this._duration > 1200 ? 1200 : this._duration;
    this._animationStartTime = performance.now();
    this._animate();
  }

  onScroll = ({ scrollOffset, scrollUpdateWasRequested }) => {
    if (scrollUpdateWasRequested) {
      this._scrollOffsetInitial = scrollOffset;
    }
    if (this.props.scrollToLocation === "get_max_scroll") {
      this.doneListScrollMax.current = scrollOffset;
      this.props.setScrollToLocation("unset");
    }
  };
}

export default React.forwardRef((props, ref) => {
  return <AnimatedList {...props} listRef={ref} />;
});
